module.exports = __webpack_public_path__ + "static/media/bedroom-3-150x150.df50df56.jpg";